import DocMarkdown from '@/components/DocMarkdown';

import { bridgeDocs } from './bridgeDocs';

/** 接入示例 tab：以 docs/bridge/007-sdk 为入口，支持站内跳转到其它 bridge 文档。 */
export default function IntegrationSampleTab() {
  return <DocMarkdown docs={bridgeDocs} docPath="bridge/007-sdk/index.md" />;
}
